import React, { useEffect, useState, useRef } from 'react';
import { Space, Table, Tag, Card, Select, Flex } from 'antd';

import { Button, Checkbox, Form, Input, Divider } from 'antd';
import ImagePicker from "components/pickers/image/MultiImagePicker"
import ProductService from 'services/product';
import { useParams, useNavigate } from "react-router"
import { useForm, useWatch } from "antd/es/form/Form";
import ProductOptionService from 'services/product_option'
import ProductVariantService from 'services/product_variant'
import { useApp } from 'contexts/app';
import InputNumber from "components/input-number"
import { PlusOutlined } from '@ant-design/icons';
const service = new ProductService();
const productOptionService = new ProductOptionService();
const productVariantService = new ProductVariantService();

const ProductOption = ({ id, value, onChange, onAddNewValue }) => {
    useEffect(() => {
        loadData();
    }, [id])
    const { prompt } = useApp();
    const [option, setOption] = useState({ values: [] })
    const loadData = async () => {
        var data = await productOptionService.get(id);
        setOption(data);
    }


  

    const addNewValue = () => {
        prompt({
            title: "Thêm mới giá trị", label: "Nhập Tên",
            onOk: async (text) => {
                const service = new ProductOptionService();
                var newValue = await service.createValue({ title: text, parent_id: id });
                loadData();
                var newValues = [...value];
                newValues.push(newValue.id);
                onChange(id, newValues);
                if(onAddNewValue){
                    onAddNewValue(newValue);
                }
            }
        });
    }




    return (
        <Select
            mode="multiple"
            style={{ width: '100%' }}
            placeholder={option.title}
            value={value}
            onChange={e => onChange(id, e)}
            options={(option.values ?? []).map(v => ({ value: v.id, label: v.title }))}
            dropdownRender={menu => (
                <>
                    {menu}
                    <Divider style={{ margin: '8px 0' }} />
                    <Space style={{ padding: '0 8px 4px' }}>
                        {/* <Input
                            placeholder="Tên phân loại"
                            ref={inputRef}
                            addonAfter={<Button size='small' type="link" icon={<PlusOutlined />} onClick={e => addNewOption()}>
                                Thêm mới
                            </Button>}
                        /> */}
                        <Button size='small' type="link" icon={<PlusOutlined />} onClick={e => addNewValue()}>
                            Thêm mới
                        </Button>
                    </Space>
                </>
            )}

        />
    )
};
export default ProductOption;